module.exports = __webpack_public_path__ + "static/media/image_2.bd1af9b7.png";